module.exports = __webpack_public_path__ + "static/scale-model-of-the-providence-athenaeum-in-providence-rhode-island-ddcfa08591ed433f37a01764d3bac92b.png";